import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import classes from "./darkMode.module.css";
import PropTypes from "prop-types";
import { DarkModeContext } from "src/context/DarkModeContext";
import { useContext } from "react";
import { style_getDesignTokens } from "./style_getDesignTokens";

function DarkMode(props) {
  const { darkMode } = useContext(DarkModeContext) || {};
  const theme = createTheme(style_getDesignTokens(darkMode ? "dark" : "light"));

  return (
    <div>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={darkMode ? classes.darkBgStyle : classes.lightBgStyle}>
          {props.children}
        </div>
      </ThemeProvider>
    </div>
  );
}

export default DarkMode;

DarkMode.propTypes = {
  children: PropTypes.node,
};
